import { render } from "./KeyVision.vue?vue&type=template&id=cfcac7b0&scoped=true"
import script from "./KeyVision.vue?vue&type=script&lang=js"
export * from "./KeyVision.vue?vue&type=script&lang=js"

import "./KeyVision.vue?vue&type=style&index=0&id=cfcac7b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfcac7b0"]])

export default __exports__